<template>
    <div class="ef" tabindex="0">
        <span class="ef__label">{{ label }}</span>
        <span class="ef__value">{{ value }}</span>
        <button 
            class="ef__edit"
            v-text="$ml.get('edit')"
            @click="$emit('click-edit')"
        />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: String,
                required: true
            }
        }
    };
</script>

<style lang="scss" scoped>
    .ef {
        position: relative;
        border-bottom: 1px solid #B8C1CC;

        &__label {
            display: block;
            font-size: 16px;
            font-weight: 600;
            color: #2F363E;
            margin-bottom: 12px;
        }

        &__value {
            display: block;
            font-size: 14px;
            font-weight: 500;
            color: #75879C;
            margin-bottom: 12px;
        }

        &__edit {
            border: none;
            background-color: transparent;
            padding: 12px 16px;
            color: #0774E7;
            font-weight: 600;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);

            &:hover,
            &:focus {
                text-decoration: underline;
            }
        }
    }
</style>